import {
  applyMiddleware,
  combineReducers,
  legacy_createStore as createStore,
} from 'redux';
import createSagaMiddleware from 'redux-saga';
import { persistReducer, persistStore } from 'redux-persist'; // defaults to localStorage for web
import rootSaga from './middleware/saga';
import * as reducers from './reducers';
import {
  common as commonPersistConfig,
  root as rootPersistConfig,
} from "./config";
import { composeWithDevTools } from '@redux-devtools/extension';

const sagaMiddleware = createSagaMiddleware();
const middlewares = [applyMiddleware(sagaMiddleware)];

const appReducer = combineReducers({
  ...reducers,
  common: persistReducer(commonPersistConfig, reducers.common),
});

const rootReducer = (state: any, action: any) => {
  if (action?.type === 'AUTH_RESET_SESSION') state = undefined;
  return appReducer(state, action);
};

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

const composeEnhancers = composeWithDevTools({
  // Specify here name, actionsDenylist, actionsCreators and other options
});

const store = createStore(
  persistedReducer,
  composeEnhancers(...middlewares)
)

// const store = createStore(
//   persistedReducer,
//   applyMiddleware(sagaMiddleware),
// );

let persistor = persistStore(store);
sagaMiddleware.run(rootSaga);

export { persistor, store };
